/* eslint-disable */
import {
  mapGetters
} from 'vuex';
import { bus } from '../../../main';
var $ = window.jQuery = require('jquery');
import toast from '../../../services/toast';
export default {
  name: 'update-quiz-reward',
  components: {},
  props: [],
  data () {
    return {
      name:'',
      amount:'',
      amount_text:'',
      currency:'',
      index:'',
      is_jackpot:false,
      submitted:false,
      quizRewardDetails:{}
    }
  },
  computed: {
    ...mapGetters([
      'getRewardPointsDetailsByIdGetters'
    ]),
    getQuizRewardDetailsFun() {
      this.quizRewardDetails = this.$store.getters.getRewardPointsDetailsByIdGetters.data
      return
    },
    setIntialStatesOfReward(){
      if(this.quizRewardDetails != undefined){
        this.name = this.quizRewardDetails.name
        this.amount = this.quizRewardDetails.amount
        this.amount_text = this.quizRewardDetails.amount_text
        this.currency = this.quizRewardDetails.currency
        this.index = this.quizRewardDetails.index
        this.is_jackpot = this.quizRewardDetails.is_jackpot
      }
      return
    }
  },
  mounted () {
    let _self = this;
    $(document).ready(function (argument) {
    $(document).click(function(event) {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
        if (!$(event.target).closest(".create_quiz_reward_popup_inner, .create_reward_btn").length) {
          _self.createRewardStatusCloseFun()
        }
      });
    });
    this.getQuizRewardDetailsFun
    this.setIntialStatesOfReward
  },
  methods: {
    jackpotStatusUpdateFun(){
      if(this.is_jackpot == true){
        this.is_jackpot = false
        this.$validator.validateAll().then((result) => {
          this.submitted = true;
          if (result) {
            let data = {
              quiz:this.$route.params.quizId,
              name: this.name,
              amount: this.amount,
              amount_text: this.amount_text,
              currency:this.currency,
              index:this.index,
              is_jackpot:this.is_jackpot,
            }
            this.$store.dispatch('updateQuizRewardPointsByIdFun', {data:{ id: this.$route.params.quiz_rewardId, data: data}})
            .then((res) => {
              toast.success(res.data.msg);
              })
              .catch((err) => {
                toast.error(err.data.data);
                this.is_jackpot = true
              })
            return
          }
        });
      }else{
        this.is_jackpot = true
        this.$validator.validateAll().then((result) => {
          this.submitted = true;
          if (result) {
            let data = {
              quiz:this.$route.params.quizId,
              name: this.name,
              amount: this.amount,
              amount_text: this.amount_text,
              currency:this.currency,
              index:this.index,
              is_jackpot:this.is_jackpot,
            }
            this.$store.dispatch('updateQuizRewardPointsByIdFun', {data:{ id: this.$route.params.quiz_rewardId, data: data}})
            .then((res) => {
              toast.success(res.data.msg);
              })
              .catch((err) => {
                toast.error(err.data.data);
                this.is_jackpot = false
              })
            return
          }
        });
      }
    },
    createRewardsSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            quiz:this.$route.params.quizId,
            name: this.name,
            amount: this.amount,
            amount_text: this.amount_text,
            currency:this.currency,
            index:this.index,
          }
          this.$store.dispatch('updateQuizRewardPointsByIdFun', {data:{ id: this.$route.params.quiz_rewardId, data: data}})
          .then((res) => {
            toast.success(res.data.msg);
            })
            .catch((err) => {})
          return
        }
      });
    },
    createRewardStatusCloseFun(){
      bus.$emit('createRewardStatusBus', false);
      $('body').removeClass("createQuizReward")
    }
  },
  watch:{
    getQuizRewardDetailsFun() {
      this.quizRewardDetails = this.$store.getters.getRewardPointsDetailsByIdGetters.data
      return
    },
    setIntialStatesOfReward(){
      if(this.quizRewardDetails != undefined){
        this.name = this.quizRewardDetails.name
        this.amount = this.quizRewardDetails.amount
        this.amount_text = this.quizRewardDetails.amount_text
        this.currency = this.quizRewardDetails.currency
        this.index = this.quizRewardDetails.index
        this.is_jackpot = this.quizRewardDetails.is_jackpot
      }
      return
    }
  }
}